import { AnyAction, combineReducers } from '@reduxjs/toolkit';
import userInfo, { userLogoutAction } from 'src/userInfo/slice';
import airlines from 'src/pages/airlines/slice';
import airports from 'src/pages/airports/slice';
import tokens from 'src/pages/tokens/slice';
import users from 'src/pages/users/slice';
import cities from 'src/pages/cities/slice';
import subsRoutes from 'src/pages/subsRoutes/slice';
import documentTypes from 'src/pages/documentTypes/slice';
import quotaCategories from 'src/pages/quotaCategories/slice';
import passengerTypes from 'src/pages/passengerTypes/slice';
import dataSearch from 'src/pages/dataSearch/slice';
import statistics from 'src/pages/statistics/slice';
import exceedanceReport from 'src/pages/exceedanceReport/slice';
import flightRound from 'src/pages/flightRound/slice';
import couponEdits from 'src/pages/couponEdits/slice';
import ticketEdits from 'src/pages/ticketEdits/slice';
import reportContracts from 'src/pages/reportContracts/slice';
import subsidyReportList from 'src/pages/subsidyReports/slice';
import subsidyReportCard from 'src/pages/subsidyReportCard/slice';
import eventLog from 'src/pages/eventLog/slice';

const appReducer = combineReducers({
    userInfo,
    airlines,
    airports,
    tokens,
    users,
    cities,
    subsRoutes,
    documentTypes,
    passengerTypes,
    quotaCategories,
    dataSearch,
    statistics,
    exceedanceReport,
    flightRound,
    couponEdits,
    ticketEdits,
    reportContracts,
    subsidyReportList,
    subsidyReportCard,
    eventLog
});

const rootReducer = (state: any, action: AnyAction) => {
    if (action.type === userLogoutAction.type) {
        return appReducer(undefined, action);
    }
    return appReducer(state, action);
};

export default rootReducer;
